import api from "@/api";
import store from "@/store/";
const state = {
  dashboardData: {},
  NOTIFICATIONS: [],
  CUSTOMERS: [],
  STATUS_LIST: [],
  ULDTYPES: [],
  SV_CARDDATA: []
};
const getters = {
  data: state => {
    return state.dashboardData;
  },
  notifications: state => {
    return state.NOTIFICATIONS;
  },
  customers: state => {
    return state.CUSTOMERS;
  },
  statusList: state => {
    return state.STATUS_LIST;
  },
  uldTypes: state => {
    return state.ULDTYPES;
  },
  cardData: state => {
    return state.SV_CARDDATA;
  },
  client: state => {
    return state.CLIENT_ID;
  }
};
const actions = {
  async getData({ commit }) {
    const result = await api.get(`/api/v1/dashboard/get_status/`);
    if (result && result.status == 200) {
      commit("setData", result.data.data);
      return true;
    }
    return false;
  },
  async getNotifications({ commit }) {
    const resp = await api.get(`/api/v1/dashboard/get_notifications/`);
    if (resp) {
      // console.log(resp);
      commit("SET_NOTIFICATIONS", resp.data.data.msg);
    }
  },
  async updateNotification({ commit }, payload) {
    const resp = await api.put(
      `/api/v1/dashboard/update_notification/${payload.id}/`
    );
    if (resp) {
      commit("UPDATE_NOTIFICATION", payload);
      return true;
    }
  },
  addNotification({ state, commit }, payload) {
    let check = state.NOTIFICATIONS.find(o => o.id == payload.id);
    if (!check) {
      commit("ADD_NOTIFICATION", payload);
    }
  },
  async getCustomers({ commit }) {
    let user = store.getters["auth/user"];
    let uri = (user.user_type == 7 ? `?customer_id=${user.id}` : ``);
    let resp = await api.get(`/api/v1/dashboard/status_and_customers/${uri}`);
    if (resp && resp.data) {
      commit("SET_CUSTOMERS", resp.data.data.customers);
      commit("SET_STATUSLIST", resp.data.data.status);
      commit("SET_ULDTYPES", resp.data.data.uld_types);
    }
  },
  async jo_status({ commit }) {
    let customers = await api.get(`/api/v1/dashboard/status_and_customers/`);
    let uri = '';
    let user = store.getters["auth/user"];
    if (customers && customers.data) {
      let c = customers.data.data.customers;
      for(var x=0;x<=c.length;x++) {
        if(user.user_type == 7 && c[x].user_id != null && c[x].user_id == user.id) {
          commit("SET_CLIENT", c[x].id);
          uri = (user.user_type == 7 ? `?customer_id=${c[x].id}` : ``);
          break;
        }
      }
    }
    let resp = await api.get(`/api/v1/dashboard/jo_status/${uri}`);
    if (resp && resp.data) {
      commit("SET_SV_CARDDATA", resp.data.data.msg);
    }
  }
};
const mutations = {
  setData: (state, payload) => {
    state.dashboardData = payload;
  },
  SET_NOTIFICATIONS: (state, payload) => {
    state.NOTIFICATIONS = payload;
  },
  SET_CLIENT: (state, payload) => {
    state.CLIENT_ID = payload;
  },
  UPDATE_NOTIFICATION: (state, payload) => {
    let notif = state.NOTIFICATIONS.find(o => o.id == payload.id);
    if (notif) {
      notif.is_read = 1;
    }
  },
  ADD_NOTIFICATION: (state, payload) => {
    let list = state.NOTIFICATIONS;
    list.pop();
    list.unshift(payload);
    state.NOTIFICATIONS = list;
  },
  SET_CUSTOMERS: (state, payload) => {
    state.CUSTOMERS = payload;
  },
  SET_STATUSLIST: (state, payload) => {
    state.STATUS_LIST = payload;
  },
  SET_SV_CARDDATA: (state, payload) => {
    state.SV_CARDDATA = payload;
  },
  SET_ULDTYPES: (state, payload) => {
    state.ULDTYPES = payload;
  }
};

export default {
  state,
  getters,
  actions,
  mutations,
  namespaced: true
};
